import { useQuery, UseQueryResult } from '@tanstack/react-query';
import ServicesContext from '../../global/services/ServicesContext';
import { useContext } from 'react';
import { currentUserKeys } from './queryKeyFactory';
import { UserPermissionsResponse } from '../../Model/responseDtos/UserPermissionsResponse';

export function useGetUserPermissions(): UseQueryResult<UserPermissionsResponse, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getUserPermissions = async () => {
    if (servicesCtx?.currentUserService) {
      return servicesCtx.currentUserService.getUserPermissions();
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: currentUserKeys.userPermissions,
    queryFn: getUserPermissions,
    retry: 0,
    staleTime: Infinity,
    gcTime: 28800000
  });
}
